import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#18181b] py-20 px-4" data-id="element-81">
      <div className="max-w-3xl mx-auto text-center" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex justify-center mb-8" data-id="element-83">
          <div className="bg-emerald-900/30 p-6 rounded-full border border-emerald-500/20" data-id="element-84">
            <ShieldCheckIcon className="w-20 h-20 text-emerald-500" data-id="element-85" />
          </div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-86">
          Garantía Total de 7 Días
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="text-lg md:text-xl text-zinc-400 leading-relaxed" data-id="element-87">
          Si tenés cualquier inconveniente con tu compra, te devolvemos el 100%
          del dinero sin preguntas. Tenés 7 días desde tu compra para pedirlo.
          Así de simple. Comprás sin riesgo.
        </motion.p>
      </div>
    </section>;
}